import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToggleService } from '../../shared/toggle-service/toggle.service';
import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import { calculateDays, AlertType } from '../../helpers'

@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  alertType: 'warning' | 'danger' | 'custom';
  showAlert = false;
  userData:any
  constructor(
    readonly toggleService: ToggleService,
    private readonly userService: UserService,
    private readonly accountService: AccountService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const user = this.userService.getUserDetails(false)
    if (user && user.userId) {
      this.getUserInfo(user.userId)
    }
  }

  getUserInfo(userId: string) {
    this.accountService.getUserDetails(userId).subscribe(
      (data) => {
        this.userData = data
        this.processBanner()
      },
    );
  }

  processBanner() {
    const userClaim = this.userService.getUserClaim();
    const days = calculateDays(this.userData?.planExpiration)

    if (days <= 0 && userClaim['termhub:plan'] === 'GRACE_PERIOD') {
      this.alertType = AlertType['GRACEPERIOD']
      this.showAlert = true
    } else if (days <= 0 && userClaim['termhub:plan'] === 'EXPIRED') {
      this.alertType = AlertType['EXPIRED']
      this.showAlert = true
    } else if (days <= 30) {
      this.alertType = AlertType['WARNING']
      this.showAlert = true
    }

    this.cdr.detectChanges()
  }

  closeAlert() {
    this.showAlert = false
  }
}
